import React, {FunctionComponent} from 'react';

interface BannerProps {
	image: any;
	title: string;
	body: string;
	subBody?: string;
	customStyles?: any;
}

const styles = {
	container: {
		width: '80rem',
		backgroundColor: 'white',
		height: '10rem',
		padding: 20,
		borderWidth: '1px',
		border: 'solid',
		marginBottom: 20,
		borderColor: '#EBEBEB',
		overflow: 'hidden'
	},
	img: {
		width: '10%', 
		height: '80%',
		marginRight: 20
	},
	title: {
		fontWeight: 'bold',
		fontSize: '16px',
		marginBottom: 10
	}
};

const Banner: FunctionComponent<BannerProps> = ({
	image,
	title,
	body,
	subBody = "",
	customStyles = {},
}) => {
	return <div style={{...styles.container, ...customStyles}}>
        <div style={{display: 'flex', flexDirection: 'row'}}>
            <img src={image} style={styles.img}/>
            <div style={{flexDirection: 'column', display: 'flex'}}>
                <label style={styles.title}>{title}</label>
                <label style={{color: '#7F7F7F'}}>{body}</label>
				<label style={{color: '#7F7F7F', marginTop: 10}}>{subBody}</label>
            </div>
        </div>
    </div>;
};

export default Banner;
